import React from 'react';
import { Link } from 'react-router-dom';
import { BedDoubleIcon, FootprintsIcon, StarIcon, UsersIcon } from 'lucide-react';
import { VerificationBadge } from './VerificationBadge';
import { ReportControls } from '../trust/ReportControls';
import { naira, pluralize } from '../../utils/format';
import type { Listing } from '../../types/housing';
interface ListingCardProps {
  listing: Listing;
  selected: boolean;
  onHover: (id: string | null) => void;
  onSelect: (id: string) => void;
}
export function ListingCard({
  listing,
  selected,
  onHover,
  onSelect
}: ListingCardProps) {
  return <article onMouseEnter={() => onHover(listing.id)} onMouseLeave={() => onHover(null)} onFocus={() => onHover(listing.id)} className={`rounded-card border bg-surface transition-colors duration-150 ease-out ${selected ? 'border-brand-700' : 'border-line hover:border-line-strong'}`} data-id="element-1974" data-mp="1wi09x6f60qvb">
      <div className="flex gap-4 p-4" data-id="element-1975" data-mp="32xao2dizubx1">
        <Link to={`/housing/${listing.id}`} onClick={() => onSelect(listing.id)} className="hidden shrink-0 sm:block" data-id="element-1976" data-mp="330gebw3czjuc">
          <img src={listing.image} alt={listing.name} className="h-28 w-40 rounded-lg object-cover" loading="lazy" data-id="element-1977" data-mp="10cwflvcvsp4j" />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col" data-id="element-1978" data-mp="19exboowdp54m">
          <div className="flex items-start justify-between gap-3" data-id="element-1979" data-mp="19cb6ux0vh3q3">
            <div className="min-w-0" data-id="element-1980" data-mp="cpy6xjv06lh6">
              <Link to={`/housing/${listing.id}`} onClick={() => onSelect(listing.id)} className="text-[15px] font-semibold text-ink hover:text-brand-800" data-id="element-1981" data-mp="hnhk0gfyss7j">
                {listing.name}
              </Link>
              <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-1982" data-mp="qh2xzxkb25fw">
                {listing.kind} · {listing.neighbourhood}
              </p>
            </div>
            <div className="shrink-0 text-right" data-id="element-1983" data-mp="3u43ajqqzsclx">
              <p className="cz-num text-[15px] font-semibold text-ink" data-id="element-1984" data-mp="3u2s41j65wqr4">
                {naira(listing.rentPerYear)}
              </p>
              <p className="text-[12px] text-ink-subtle" data-id="element-1985" data-mp="wbtgk08xjdrl">per year</p>
            </div>
          </div>

          <div className="mt-2" data-id="element-1986" data-mp="1b0pjxk01k2lv">
            <VerificationBadge state={listing.verification} data-id="element-1987" data-mp="1aywgedkq5yi3" />
          </div>

          <p className="cz-num mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-[13px] text-ink-muted" data-id="element-1988" data-mp="160uxptr7o175">
            <span className="inline-flex items-center gap-1.5" data-id="element-1989" data-mp="icbmp6gs1abd">
              <FootprintsIcon className="h-3.5 w-3.5" data-id="element-1990" data-mp="dcp9gx0y7u2k" />
              {listing.minutesToCampus} min to campus
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-1991" data-mp="rd9qbnnazftf">
              <UsersIcon className="h-3.5 w-3.5" data-id="element-1992" data-mp="navalcexkw6d" />
              {listing.occupants === 1 ? 'Single occupancy' : `${listing.occupants} per room`}
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-1993" data-mp="22pkf7iyxersl">
              <BedDoubleIcon className="h-3.5 w-3.5" data-id="element-1994" data-mp="1yoqpql5u54xl" />
              {pluralize(listing.bedsAvailable, 'bed')} free
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-1995" data-mp="26801gl1tdfpt">
              <StarIcon className="h-3.5 w-3.5" data-id="element-1996" data-mp="2b9fim20vf22x" />
              {listing.rating.toFixed(1)} ({listing.reviewCount})
            </span>
          </p>

          <div className="mt-3 flex items-end justify-between gap-3" data-id="element-1997" data-mp="1wdhriy5t0nxk">
            <p className="text-[12px] text-ink-subtle" data-id="element-1998" data-mp="21aqav22ouy0e">Available from {listing.availableFrom}</p>
            <ReportControls subject={listing.name} surface="listing" data-id="element-1999" data-mp="2p0ay3x5vkhfh" />
          </div>
        </div>
      </div>
    </article>;
}